import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.avatars.index-page', () => {
  void import('./internal/avatars__index-page').then(({ default: Component }) => Component());
});
